// Regroupement des messages du fil, comme dans les messageries courantes
// (WhatsApp, Slack, Teams) : une suite de messages du meme auteur, a moins de
// 5 minutes d'intervalle, forme un bloc. L'avatar et la ligne « nom · role ·
// heure » ne s'affichent qu'une fois, sous le dernier message du bloc.
export const MESSAGE_GROUP_WINDOW_MS = 5 * 60 * 1000

export type GroupableMessageType = {
  id: string
  userId: string
  sentAt: string
}

export type MessageGroupingType = {
  // rattache au message du dessus
  withPrevious: boolean
  // le message du dessous continue le bloc
  withNext: boolean
}

export type MessageGroupingOptionsType<T> = {
  // message qui ne se regroupe jamais (carte de session)
  isStandalone: (message: T) => boolean
  // un separateur de jour s'affiche avant ce message
  startsNewDay: (message: T) => boolean
}

function joins<T extends GroupableMessageType>(
  previous: T | undefined,
  next: T | undefined,
  options: MessageGroupingOptionsType<T>,
): boolean {
  if (!previous || !next) return false
  if (previous.userId !== next.userId) return false
  if (options.isStandalone(previous) || options.isStandalone(next)) return false
  if (options.startsNewDay(next)) return false
  const gap = new Date(next.sentAt).getTime() - new Date(previous.sentAt).getTime()
  return Number.isFinite(gap) && gap >= 0 && gap < MESSAGE_GROUP_WINDOW_MS
}

export function getMessageGrouping<T extends GroupableMessageType>(
  messages: T[],
  options: MessageGroupingOptionsType<T>,
): Record<string, MessageGroupingType> {
  const grouping: Record<string, MessageGroupingType> = {}
  messages.forEach((message, index) => {
    grouping[message.id] = {
      withPrevious: joins(messages[index - 1], message, options),
      withNext: joins(message, messages[index + 1], options),
    }
  })
  return grouping
}
